"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // tslint:disable:jsx-no-lambda

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var BB8Button_1 = __importDefault(require("./BB8Button"));

require("./BB8CarouselItem.scss");

var BB8CarouselItemStyle;

(function (BB8CarouselItemStyle) {
  BB8CarouselItemStyle[BB8CarouselItemStyle["default"] = 0] = "default";
  BB8CarouselItemStyle[BB8CarouselItemStyle["badge"] = 1] = "badge";
})(BB8CarouselItemStyle = exports.BB8CarouselItemStyle || (exports.BB8CarouselItemStyle = {})); // TODO: decouple implementation from business logic
// e.g. what do I do if I want to pass a completely different
// item template to the carousel component?


function BB8CarouselItem(props) {
  return react_1.default.createElement("div", {
    className: classnames_1.default('BB8Carousel-item', {
      'selected-carousel-item': props.selectedItem && props.selectedItem.id === props.item.id
    }),
    onClick: function onClick() {
      return props.select(props.item);
    },
    key: props.item.id,
    id: 'carousel-item-' + props.item.id
  }, !props.styleType ? react_1.default.createElement("div", {
    className: "card-inner-wrapper"
  }, props.allowEdit ? react_1.default.createElement(BB8Button_1.default, {
    color: "primary",
    size: "small",
    variant: "contained",
    className: "edit-icon",
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
      props.clickEdit(props.item);
    }
  }, "edit") : null, react_1.default.createElement("h5", null, props.item.id), react_1.default.createElement("div", {
    className: "description"
  }, react_1.default.createElement("p", null, props.item.desc)), react_1.default.createElement("p", null, react_1.default.createElement("span", null, props.item.total), " locations mapped")) : // StyleType = badge
  react_1.default.createElement("div", {
    className: "card-inner-wrapper"
  }, react_1.default.createElement("small", null, props.item.id), react_1.default.createElement("h5", null, props.item.desc), react_1.default.createElement("div", {
    className: "subItems-wrapper"
  }, props.item.subItems && props.item.subItems.map(function (subItem) {
    return react_1.default.createElement("div", {
      className: "subItem"
    }, subItem);
  }))));
}

exports.default = BB8CarouselItem;